import { jsx as e } from "react/jsx-runtime";
import { Popover as r } from "@base-ui/react/popover";
import { cn as i } from "../../lib/utils.js";
function f({ ...o }) {
  return /* @__PURE__ */ e(r.Root, { "data-slot": "popover", ...o });
}
function c({ ...o }) {
  return /* @__PURE__ */ e(r.Trigger, { "data-slot": "popover-trigger", ...o });
}
function u({
  className: o,
  align: t = "center",
  alignOffset: a = 0,
  side: n = "bottom",
  sideOffset: d = 4,
  ...s
}) {
  return /* @__PURE__ */ e(r.Portal, { children: /* @__PURE__ */ e(
    r.Positioner,
    {
      align: t,
      alignOffset: a,
      side: n,
      sideOffset: d,
      className: "isolate z-50",
      children: /* @__PURE__ */ e(
        r.Popup,
        {
          "data-slot": "popover-content",
          className: i(
            "z-50 flex w-72 origin-(--transform-origin) flex-col gap-2.5 rounded-lg bg-popover p-2.5 text-sm text-popover-foreground shadow-md ring-1 ring-foreground/10 outline-hidden duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
            o
          ),
          ...s
        }
      )
    }
  ) });
}
function g({ className: o, ...t }) {
  return /* @__PURE__ */ e(
    "div",
    {
      "data-slot": "popover-header",
      className: i("flex flex-col gap-0.5 text-sm", o),
      ...t
    }
  );
}
function v({ className: o, ...t }) {
  return /* @__PURE__ */ e(
    r.Title,
    {
      "data-slot": "popover-title",
      className: i("font-medium", o),
      ...t
    }
  );
}
function P({
  className: o,
  ...t
}) {
  return /* @__PURE__ */ e(
    r.Description,
    {
      "data-slot": "popover-description",
      className: i("text-muted-foreground", o),
      ...t
    }
  );
}
export {
  f as Popover,
  u as PopoverContent,
  P as PopoverDescription,
  g as PopoverHeader,
  v as PopoverTitle,
  c as PopoverTrigger
};
//# sourceMappingURL=popover.js.map
